<template>
    <div class="curriculumMsg form">
        <el-form class="sellWayForm" :model="item" ref="sellWayForm" label-width="105px" :rules="rules">
            <el-form-item label="价格设置" prop="feetype">
                <el-radio :label="1" v-model="item.feetype" :disabled="isDisabled" @change="freeOrNofree">免费</el-radio>
                <el-radio :label="2" v-model="item.feetype" @change="freeOrNofree" :disabled="isDisabled">付费</el-radio>
                <!-- <el-form-item label="分享解锁" v-show="String(item.feetype) === '1'" class="share">
                    <el-switch ref="share" v-if="tryRead === '1'" :value="item.checkView.share.status" :disabled="isDisabled"></el-switch>
                    <el-switch ref="share" v-else v-model="item.checkView.share.status" :disabled="isDisabled"></el-switch>
                    <span class="shareTips">有助于专题推广</span>
                </el-form-item> -->
            </el-form-item>
            <el-form-item class="projectPriceBox" prop="projectPrice" label="题库原价" v-show="String(item.feetype) === '2'">
                <div class="projectPrice">
                    <el-input v-model.trim="item.uprice" placeholder="请输入题库原价" :disabled="isDisabled"></el-input>
                    <span>元</span>
                </div>
            </el-form-item>
             <el-form-item class="priceBox" prop="price" label="题库现价" v-show="String(item.feetype) === '2'">
                <div class="price">
                    <el-input v-model.trim="item.saleprice" placeholder="请输入题库现价" :disabled="isDisabled"></el-input>
                    <span>元</span>
                </div>
            </el-form-item>
            <!-- <p class="tips" v-show="String(item.feetype) === '2'">商品没有其他优惠（如拼团）的情况下，题库原价在商品详情会以划线形式显示 <a href="">什么是规划价格</a></p> -->
            <!-- <el-form-item label="促销设置" v-show="String(item.feetype) === '2'" class="promotionSet">
                <div class="helpSell">
                    <el-form-item label="助力减价" class="reduceMg slider">
                        <el-switch v-model="item.checkView.assistance.status" :disabled="isDisabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="助力次数" class="reduceMg" prop="helpNum">
                        <el-input v-model.trim="item.checkView.assistance.datacond" :disabled="isDisabled?isDisabled:!item.checkView.assistance.status"></el-input>
                    </el-form-item>
                    <el-form-item label="减免价格(元)" prop="reducePrice">
                        <el-input v-model.trim="item.checkView.assistance.discountvalue" :disabled="isDisabled?isDisabled:!item.checkView.assistance.status"></el-input>
                    </el-form-item>
                    <el-form-item label="有效期(小时)" prop="validity">
                        <el-input v-model.trim="item.checkView.assistance.expirehours" :disabled="isDisabled?isDisabled:!item.checkView.assistance.status"></el-input>
                    </el-form-item>
                </div>
                <div class="flashSale">
                    <el-form-item label="限时优惠" class="reduceMg slider">
                        <el-switch v-model="item.checkView.limitedTime.status" :disabled="isDisabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="优惠时间" class="reduceMg discountsTime" prop="discountsTime">
                        <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" v-model="item.checkView.limitedTime.datacond" :disabled="isDisabled?isDisabled:!item.checkView.limitedTime.status" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="优惠价格(元)" prop="discountsPrice">
                        <el-input v-model.trim="item.checkView.limitedTime.discountvalue" :disabled="isDisabled?isDisabled:!item.checkView.limitedTime.status"></el-input>
                    </el-form-item>
                </div>
                <div class="allReduce">
                    <el-form-item label="拼团减价" class="reduceMg slider">
                        <el-switch v-model="item.checkView.assemble.status" :disabled="isDisabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="拼团人数" class="reduceMg" prop="groupNum">
                        <el-input v-model.trim="item.checkView.assemble.datacond" :disabled="isDisabled?isDisabled:!item.checkView.assemble.status"></el-input>
                    </el-form-item>
                    <el-form-item label="减免价格(元)" prop="groupReducePrice">
                        <el-input v-model.trim="item.checkView.assemble.discountvalue" :disabled="isDisabled?isDisabled:!item.checkView.assemble.status"></el-input>
                    </el-form-item>
                    <el-form-item label="有效期(小时)" prop="groupValidHours">
                        <el-input v-model.trim="item.checkView.assemble.expirehours" :disabled="isDisabled?isDisabled:!item.checkView.assemble.status"></el-input>
                    </el-form-item>
                </div>
            </el-form-item> -->
        </el-form>
    </div>
</template>
<script>
export default {
    name: 'curriculumMsg',
    data() {
        // 助力减价
        // 检查助力次数
        let checkHelpNum = (rule, value, callback) => {
            let numRegular = /^[1-9]\d*$/
            if (this.item.checkView.assistance.status) {
                if (!this.item.checkView.assistance.datacond) {
                    callback(new Error('请输入助力次数'))
                } else if (!numRegular.test(this.item.checkView.assistance.datacond)) {
                    callback(new Error('请输入正整数'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查减免价格
        let checkReducePrice = (rule, value, callback) => {
            let numRegular = /(^[0-9]{1,6}$)|(^[0-9]{1,6}[.]{1}[0-9]{1,2}$)/
            if (this.item.checkView.assistance.status) {
                if (!this.item.checkView.assistance.discountvalue) {
                    callback(new Error('请输入减免价格'))
                } else if (!numRegular.test(this.item.checkView.assistance.discountvalue)) {
                    callback(new Error('整数6位小数2位'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查有效时间
        let checkValidity = (rule, value, callback) => {
            let numRegular = /^[1-9]\d*$/
            if (this.item.checkView.assistance.status) {
                if (!this.item.checkView.assistance.expirehours) {
                    callback(new Error('请输入有效期'))
                } else if (!numRegular.test(Number(this.item.checkView.assistance.expirehours))) {
                    callback(new Error('请输入正整数'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 限时优惠
        // 检查优惠时间
        let checkDiscountsTime = (rule, value, callback) => {
            if (this.item.checkView.limitedTime.status) {
                if (!this.item.checkView.limitedTime.datacond) {
                    callback(new Error('请选择优惠时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查优惠价格
        let checkDiscountsPrice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (this.item.checkView.limitedTime.status) {
                if (!this.item.checkView.limitedTime.discountvalue) {
                    callback(new Error('请输入优惠价格'))
                } else if (!numRegular.test(this.item.checkView.limitedTime.discountvalue)) {
                    callback(new Error('数据格式不正确'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 拼团减价
        // 检查拼团人数
        let checkGroupNum = (rule, value, callback) => {
            let numRegular = /^[1-9]\d*$/
            if (this.item.checkView.assemble.status) {
                if (!this.item.checkView.assemble.datacond) {
                    callback(new Error('请输入拼团人数'))
                } else if (!numRegular.test(this.item.checkView.assemble.datacond)) {
                    callback(new Error('请输入正整数'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查减免价格
        let checkGroupReducePrice = (rule, value, callback) => {
            let numRegular = /(^[0-9]{1,6}$)|(^[0-9]{1,6}[.]{1}[0-9]{1,2}$)/
            if (this.item.checkView.assemble.status) {
                if (!this.item.checkView.assemble.discountvalue) {
                    callback(new Error('请输入减免价格'))
                } else if (!numRegular.test(this.item.checkView.assemble.discountvalue)) {
                    callback(new Error('小数2位'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查有效期
        let checkGroupValidHours = (rule, value, callback) => {
            let numRegular = /^[1-9]\d*$/
            if (this.item.checkView.assemble.status) {
                if (!this.item.checkView.assemble.expirehours) {
                    callback(new Error('请输入有效期'))
                } else if (!numRegular.test(Number(this.item.checkView.assemble.expirehours))) {
                    callback(new Error('请输入正整数'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查题库现价
        let checkArticlePrice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (String(this.item.feetype) === '2') {
                if (!this.item.saleprice) {
                    callback(new Error('请输入题库现价'))
                } else if (!numRegular.test(this.item.saleprice)) {
                    callback(new Error('两位小数哦！'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // 检查题库原价
        let checkProjectPrice = (rule, value, callback) => {
            let numRegular = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)/
            if (String(this.item.feetype) === '2') {
                if (!this.item.uprice) {
                    callback()
                } else if (!numRegular.test(this.item.uprice)) {
                    callback(new Error('两位小数哦！'))
                } else if (this.item.uprice > 0 && parseFloat(this.item.uprice) <= parseFloat(this.item.saleprice)) {
                    callback(new Error('题库原价不能低于题库现价'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            isDisabled: false,
            item: {
                feetype: 1, // 售卖方式
                uprice: '', // 题库原价
                saleprice: '', // 销售价格
                checkView: {
                    limitedTime: {
                        id: '',
                        status: false,
                        mktype: 1, // 1限时优惠
                        discounttype: 2,
                        discountvalue: '',
                        expirehours: '',
                        datacond: '',
                        mark: 'add'
                    },
                    assemble: {
                        id: '',
                        status: false,
                        mktype: 3, // 3拼团减价
                        discounttype: 2,
                        discountvalue: '',
                        expirehours: '48',
                        datacond: '',
                        mark: 'add'
                    },
                    assistance: {
                        id: '',
                        status: false,
                        mktype: 5, // 5 助力减价
                        discounttype: 2,
                        discountvalue: '',
                        expirehours: '48',
                        datacond: '',
                        mark: 'add'
                    },
                    share: {
                        id: '',
                        status: false,
                        mktype: 6, // 6分享解锁
                        discounttype: 2,
                        discountvalue: '',
                        expirehours: '',
                        datacond: 1,
                        mark: 'add'
                    }
                }
            },
            rules: {
                helpNum: [
                    {validator: checkHelpNum, trigger: 'blur'}
                ],
                reducePrice: [
                    {validator: checkReducePrice, trigger: 'blur'},
                    {min: 1, max: 9, message: '数据过长', trigger: 'blur'}
                ],
                validity: [
                    {validator: checkValidity, trigger: 'change'}
                ],
                discountsTime: [
                    {validator: checkDiscountsTime, trigger: 'change'}
                ],
                discountsPrice: [
                    {validator: checkDiscountsPrice, trigger: 'blur'}
                ],
                groupNum: [
                    {validator: checkGroupNum, trigger: 'blur'}
                ],
                groupReducePrice: [
                    {validator: checkGroupReducePrice, trigger: 'blur'},
                    {min: 1, max: 9, message: '数据过长', trigger: 'blur'}
                ],
                groupValidHours: [
                    {validator: checkGroupValidHours, trigger: 'change'}
                ],
                price: [
                    {validator: checkArticlePrice, trigger: 'blur'}
                ],
                projectPrice: [
                    {validator: checkProjectPrice, trigger: 'blur'}
                ],
                feetype: [
                    {required: true, message: '请选择售卖方式', trigger: 'blur'}
                ]
            }
        }
    },
    props: [
        'tryRead'
    ],
    methods: {
        setDisabled() {
            this.isDisabled = true
        },
        freeOrNofree() {
            this.item.uprice = null
            this.item.saleprice = null
            this.item.checkView = {
                limitedTime: {
                    id: '',
                    status: false,
                    mktype: 1, // 1限时优惠
                    discounttype: 2,
                    discountvalue: '',
                    expirehours: '',
                    datacond: '',
                    mark: 'add'
                },
                assemble: {
                    id: '',
                    status: false,
                    mktype: 3, // 3拼团减价
                    discounttype: 2,
                    discountvalue: '',
                    expirehours: '48',
                    datacond: '',
                    mark: 'add'
                },
                assistance: {
                    id: '',
                    status: false,
                    mktype: 5, // 5 助力减价
                    discounttype: 2,
                    discountvalue: '',
                    expirehours: '48',
                    datacond: '',
                    mark: 'add'
                },
                share: {
                    id: '',
                    status: false,
                    mktype: 6, // 6分享解锁
                    discounttype: 2,
                    discountvalue: '',
                    expirehours: '',
                    datacond: 1,
                    mark: 'add'
                }
            }
            if (this.item.checkView.feetype === '2') {
                this.item.checkView.share.status = false
            }
        },
        setItem(parameter) {
            this.item.feetype = parameter.feetype
            this.item.uprice = parameter.uprice
            this.item.saleprice = parameter.saleprice
            if (parameter.checkView) {
                this.item.checkView = parameter.checkView
            }
        }
    },
    watch: {
        'item.feetype': {
            handler(newFeetype, oldFeetype) {
                if (newFeetype === 2) {
                    this.item.checkView.share.status = false
                } else if (newFeetype === 1 && this.tryRead === '1') {
                    this.item.checkView.share.status = true
                }
                let free = JSON.stringify(
                    {
                        feetype: this.item.feetype,
                        uprice: this.item.uprice,
                        saleprice: this.item.saleprice
                    }
                )
                   
                this.$emit('changeWay', free)
            }
        },
        'item.checkView.limitedTime.status': {
            handler(newV, oldV) {
                if (!newV) {
                    this.$refs.sellWayForm.validate(v => {
                        if (!v) {
                            return false
                        }
                    })
                } else {
                    this.$refs.sellWayForm.validate(v => {
                        return true
                    })
                }
                if (newV) {
                    this.item.checkView.assemble.status = false
                    this.item.checkView.assistance.status = false
                }
            }
        },
        'item.checkView.assemble.status': {
            handler(newV, oldV) {
                if (!newV) {
                    this.$refs.sellWayForm.validate(v => {
                        if (!v) {
                            return false
                        }
                    })
                } else {
                    this.$refs.sellWayForm.validate(v => {
                        return true
                    })
                }
                if (newV) {
                    this.item.checkView.limitedTime.status = false
                    this.item.checkView.assistance.status = false
                }
            }
        },
        'item.checkView.assistance.status': {
            handler(newV, oldV) {
                if (!newV) {
                    this.$refs.sellWayForm.validate(v => {
                        if (!v) {
                            return false
                        }
                    })
                } else {
                    this.$refs.sellWayForm.validate(v => {
                        return true
                    })
                }
                if (newV) {
                    this.item.checkView.limitedTime.status = false
                    this.item.checkView.assemble.status = false
                }
            }
        },
        'tryRead': {
            handler(newV, oldV) {

            }
        },
        'item.saleprice': {
            handler() {
                // if (this.item.uprice > 0) {
                    this.$refs.sellWayForm.validate(v => {
                        if (!v) {
                            return false
                        }
                    })
                    let free = JSON.stringify(
                        {
                            feetype: this.item.feetype,
                            uprice: this.item.uprice,
                            saleprice: this.item.saleprice
                        }
                    )
                   
                this.$emit('changeWay', free)
                // }
                
            },
            immediate: false
        },
        'item.uprice': {
            handler(newV) {
                if (newV === '0.00' || newV === '0.0') {
                    this.item.uprice = ''
                }
                let free = JSON.stringify(
                    {
                        feetype: this.item.feetype,
                        uprice: this.item.uprice,
                        saleprice: this.item.saleprice
                    }
                )
                   
                this.$emit('changeWay', free)
                
            }  
        },
        deep: true,
        immediate: true
    }
}
</script>
<style lang="scss">
@import "~common/scss/base";
.curriculumMsg{
    width: 805px;
    .sellWayForm{
        background: #F5F7FA;
        padding: 15px 24px;
        .share{
            .el-form-item__label::after{
                content: "";
            }
        }
        .priceBox,.projectPrice{
            display:flex;
            .el-input{
                width: 230px;
            }
            span{
                margin-left: 14px;
            }
        }
        .priceBox{
            margin: 20px 0 0 85px;
            .el-form-item__label{
                text-align: left;
            }
            .el-form-item__label::after{
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__content{
                margin: 0!important;
            }
        }
        .projectPriceBox{
            margin: 10px 0 0 85px;
            .el-form-item__label{
                margin-top: 15px;
                text-align: left;
            }
            .projectPrice{
                margin-top: 15px;
            }
        }
        .tips{
            margin-top: 20px;
            margin-left: 85px;
            color:#909399;
            a{
                color: #409EFF;
            }
        }
        .shareTips{
            color: #909399;
            margin-left: 10px;
        }
        .promotionSet{
            .el-form-item__label{
                text-align: left;
            }
            .helpSell{
                display: flex;
                margin-top: 15px;
                .el-input{
                    width: 74px;
                    input{
                        height: 32px !important;
                    }
                }
                .el-form-item__label{
                    padding: 0;
                    margin-left: 10px;
                }
                .el-form-item__content{
                    width: 90px;
                }
            }
            .flashSale{
                display: flex;
                margin-top: 20px;
                .el-form-item__label{
                    padding: 0;
                    margin-left: 10px;
                }
                .el-form-item__content{
                    width: 90px;
                }
            }
            .allReduce{
                display: flex;
                margin-top: 20px;
                .el-input{
                    width: 74px;
                    input{
                        height: 32px !important;
                    }
                }
                .el-form-item__label{
                    padding: 0;
                    margin-left: 10px;
                }
                .el-form-item__content{
                    width: 90px;
                }
            }
            & > .el-form-item__label{
                padding-top: 16px;
                padding-right: 0;
            }
            .el-input{
                width: 85px !important;
            }
            .el-date-editor{
                width: 222px !important;
            }
        }
        .el-form-item__label{
            margin-left: 0!important;
        }
        .reduceMg{
            .el-form-item__label{
                width: 60px!important;
            }
            .el-form-item__content{
                margin-left: 65px !important;
                // width: 60px;
            }
        }
        .slider{
            .el-form-item__content{
                width: 40px !important;
            }
        }
        .discountsTime{
            .el-form-item__content{
                width: 222px !important;
            }
        }
        .el-form-item__content{
            margin-right: 10px;
        }
    }
}
.form{
    margin-top: 0!important;
}
</style>
